
const Facebook_Pixel_Tag_ID = "1532938127537706";
const Google_tag_Manager = "GTM-5LK8QX6R";
const Google_Analitycs_4_tag_ID = "G-DL2DVTX1RL";

export const PIXEL = Facebook_Pixel_Tag_ID;
export const GA4 = Google_Analitycs_4_tag_ID;
export const GTM = Google_tag_Manager;